<template>
  <b-container fluid class="no-sided-margin">
    <b-row>
      <b-col class="no-sided-padding">
        <b-tabs ref="warnings-tab" v-model="tab" fill pills card>
          <b-tab title="Elenco">
            <b-card header-bg-variant="light">
              <template #header>
                <div style="height: 1.5rem">
                  <span><strong><b-icon-card-checklist/>&nbsp;Errori trovate</strong></span>
                </div>
              </template>
              <b-card-body>
                <b-table sticky-header="71vh" :no-border-collapse="true" :fields="fields" :items="responses" responsive>
                  <template #cell(signedAt)="data">
                    {{ formatDateTime(data.item.signedAt) }}
                  </template>
                  <template #cell(dataEntryMode)="data">
                    <span v-if="dataEntryModeShowPill(data.item.dataEntryMode)" :class="dataEntryModeStyle(data.item.dataEntryMode)">
                      {{ dataEntryMode(data.item.dataEntryMode) }}
                    </span>
                  </template>
                  <template #cell(sentAt)="data">
                    {{ formatDateTime(data.item.sentAt) }}
                  </template>
                  <template #cell(message)="data">
                    <span v-if="data.item.message && data.item.message.length <= 45">{{ data.item.message }}</span>
                    <span v-if="data.item.message && data.item.message.length > 45" v-b-popover.hover.top="`${data.item.message}`">
                      {{ data.item.message.substring(0, 42) }}...
                    </span>
                  </template>
                  <template #cell(errors)="data">
                    <li v-for="error in data.item.errors">
                      {{ error }}
                    </li>
                  </template>
                  <template #cell(note)="data">
                    <div v-b-popover.hover.top="data.item.note" title="Nota" class="text-truncate" style="max-width: 200px"> {{ data.item.note || 'Nessuna nota' }}</div>
                  </template>
                  <template #cell(actions)="data">
                    <b-button-toolbar>
                      <b-button-group class="mr-2">
                        <b-button title="Modifica le note" v-b-tooltip.hover variant="success" ref="note" v-b-modal.noteModal @click="editNote(data.item)">
                          <b-iconstack>
                            <b-icon stacked icon="file"></b-icon>
                            <b-icon stacked icon="pencil-fill" scale="0.8" shift-h="5" shift-v="1"></b-icon>
                          </b-iconstack>
                        </b-button>
                        <b-button title="Invia" class="btn-danger" ref="send" v-on:click="sendToDitech(data.item.serviceId)">
                          <b-icon icon="envelope" aria-hidden="true"></b-icon>
                        </b-button>
                        <b-button @click="membershipDetails(data.item.serviceId)" title="Dettaglio" v-b-tooltip.hover variant="info">
                          <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                        </b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </template>
                </b-table>
              </b-card-body>
            </b-card>
            <b-pagination
              v-if="errorsAmount>100"
              align="right"
              v-model="currentPage"
              @change="retrieveDitechResponses"
              :per-page="pageSize"
              :total-rows="errorsAmount"
            ></b-pagination>
          </b-tab>
          <b-tab title="Dettaglio adesione">
            <Details v-model="membership"/>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <ModalNote :note="currentError.note" :warning-id="currentError.id" :note-saving="noteSaving" event-name="error-note-edited" @error-note-edited="saveNote"/>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></p>
    </div>
  </b-container>
</template>

<script>
import DitechResponseApi from "../api/DitechResponseApi";
import moment from "moment";
import MembershipApi from "../api/MembershipApi";
import Style from "@/Style";
import Details from "@/components/memberships/Details";
import ModalNote from "@/components/ModalNote";
import eventBus from "../EventBus";
import {customRef} from "vue";

export default {
  name: 'Errors',
  components: { ModalNote, Details },
  mounted() {
    this.retrieveDitechResponses(1)
  },
  data: () => ({
    fields: [
      {key: 'dataEntryMode', label: "Provenienza"},
      {key: 'signedAt', label: "Data firma"},
      {key: 'sentAt', label: 'Data invio'},
      {key: 'barcode', label: 'Codice tessera'},
      {key: 'code', label: 'Codice'},
      {key: 'message', label: 'Messaggio'},
      {key: 'errors', label: 'Errori'},
      {key: 'note', label: 'Note'},
      {key: 'actions', label: 'Azioni'},
    ],
    responses: [],
    tab: 0,
    membership: null,
    noteSaving: false,
    currentError: {
      id: null,
      note: null
    },
    currentPage: 1,
    pageSize: 100,
    errorsAmount: 1,
  }),
  methods: {
    dataEntryMode(dataEntryMode) {
      switch (dataEntryMode) {
        case 'CIE':
          return "Dao Fidelity App con CIE"
        case 'CNS':
          return "Dao Fidelity App con CNS"
        case 'MANUAL':
          return "Dao Fidelity App Manuale";
        case 'DIGITALIZED_MANUAL':
          return "Nuova Digitalizzazione";
        case 'DIGITALIZED_MORE':
          return "Digitalizzazione Pregresso";
        case 'DIGITALIZED_MORE_MODIFIED':
          return "Digitalizzazione Pregresso con Modifica";
      }
    },
    dataEntryModeStyle(dataEntryMode) { return Style.dataEntryModeStyle(dataEntryMode)},
    dataEntryModeShowPill(dataEntryMode){return Style.showDataEntryModePill(dataEntryMode)},
    retrieveDitechResponses(currentPage) {
      DitechResponseApi
        .getAll(currentPage, this.pageSize)
        .then(result => {
          this.responses = result.data.errors
            .map(it => {
              if (it.code === '500' && it.message === 'Internal Server Error') {
                return {...it, message: "Da inviare", code: ""}
              } else {

                return {...it.ditechResponse, ...it}
              }
            })
          this.errorsAmount = result.data.pageCount*this.pageSize
        })
    },
    sendToDitech(id) { MembershipApi.postMembershipToDitech(id) },
    membershipDetails (id) {
      eventBus.$emit("membership-detail", id)
      MembershipApi
        .findBy(id)
        .then(result => {
          console.log(result)
          this.membership = result.data
          this.tab = 1
        })
    },
    formatDateTime(date) {
      return date
        ? moment.utc(date).local().format("DD/MM/YYYY HH:mm")
        : ""
    },
    editNote (error) {
      this.currentError.id = error.id
      this.currentError.note = error.note
    },
    saveNote (data) {
      this.noteSaving = true
      DitechResponseApi.setNote(data.warningId, data.note)
        .then(() => {this.retrieveDitechResponses(this.currentPage)})
        .finally(() => this.noteSaving = false)
    }
  }
}
</script>
